import classnames from 'classnames';
import type { ReactNode } from 'react';

import { css } from '@sorare/css';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BackButton } from '#src/components/dialog/BackButton/index.tsx';

const root = css`
  width: 100%;
  &.stickyHeader {
    max-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
const content = css`
  padding: var(--double-unit);
  &.stickyHeader {
    flex: 1;
    overflow: auto;
  }
  &.noPadding {
    padding: 0;
  }
`;
const nav = css`
  position: relative;
  min-height: 60px;
  border-bottom: 1px solid var(--c-nd-100);
`;
const titleClass = css`
  flex: 1;
  text-align: center;
  margin: 0 var(--unit);
`;
const left = css`
  margin-left: var(--double-unit);
  min-width: 40px;
`;
const rightClass = css`
  margin-right: var(--double-unit);
  min-width: 40px;
`;
const footerClass = css`
  position: relative;
  min-height: 60px;
  margin: 0 var(--double-unit);
`;

type Props = {
  title?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
  backButton?: ReactNode;
  onBackButton?: () => void;
  stickyHeader?: boolean;
  noPadding?: boolean;
  footer?: ReactNode;
};
export const DialogContentWithNavigation = ({
  children,
  onBackButton,
  backButton: backButtonCustom,
  title,
  right,
  stickyHeader,
  noPadding,
  footer,
}: Props) => {
  return (
    <div className={classnames(root, { stickyHeader })}>
      <Horizontal className={nav} gap={0} center>
        <Horizontal className={left} gap={0}>
          {backButtonCustom}
          {!backButtonCustom && !!onBackButton && (
            <BackButton onBack={onBackButton} />
          )}
        </Horizontal>
        <div className={titleClass}>{title}</div>
        <Horizontal className={rightClass} gap={0} justify="end">
          {right || null}
        </Horizontal>
      </Horizontal>
      <div className={classnames(content, { stickyHeader, noPadding })}>
        {children}
      </div>
      {!!footer && (
        <Horizontal className={footerClass} gap={0} center>
          {footer}
        </Horizontal>
      )}
    </div>
  );
};
